<template>
    <div
        class="messageModalWrapper"
    >
        <div
            class="messageModalContainer"
            :class="{styleSignage: displayType === 'signage'}"
        >
            <p v-html="message" />
        </div>
        <div
            class="messageModalBg"
            @click="$emit('message-modal-off')"
        />
    </div>
</template>

<script>
export default {
    name: 'MessageModal',
    props: {
        message: {
            type: String,
            default: ''
        },
        messageModalShow: Boolean,
        displayType: {
            type: String,
            default:'signage'
        }
    },
    emits: ['message-modal-off'],

}
</script>

<style scoped>

/* メッセージモーダル */
.messageModalWrapper {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    transition: .3s;
}

.styleSignage {
    width: 70vw;
}

.styleSignage p {
    font-size: 2.5rem
}
</style>
